var map = {
	"./atos syntel.png": 2624,
	"./cyient.png": 9593,
	"./genpact.png": 6315,
	"./hcl.png": 4617,
	"./hexaware.png": 2077,
	"./itc.png": 1348,
	"./mindfire.png": 1837,
	"./niit.png": 1044,
	"./rolta.png": 8036,
	"./sonata.png": 5198,
	"./tcs.png": 8254,
	"./wns.png": 5368,
	"./zensar.png": 4656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9644;